import Request from './request'
import request_configs from "./request_configs";
import store from '@/store.js';
import consts from '@/consts.js'

async function checkAction(type){
  return Request("get","api/shops/checkAction?type="+type)
}

async function fetch(){//获取当前门店信息
  const response = await Request("get", "api/shops/view")
  if (response.data && response.data.status.isOK()) {
    store.commit("USERINFO", response.data.shop);
}
  return response;
}

async function accountFetch(){//获取当前门店信息
  const response = await Request("get", "api/shops/get-account-shop")
  if (response.data && response.data.status.isOK()) {
    store.commit("USERINFO", response.data.shop);
  }
  return response;
}

async function fetchShops(data, isActivity){//获取初始化门店列表
  if (isActivity) {
    return Request('get', "api/shops/get-active-shops", data);
  }
  return Request('get', "api/shops/index", data);
}

async function getAllShops(data) {
  data.limit = consts.limitAll; // 获取全部
  data.itemsPerPage = consts.limitAll // 获取全部
  let header = {
    'request-from': "AdminFront",
    'access-token': JSON.parse(localStorage.getItem("adminLoginData")).access_token
  }
  return Request(
      'get',
      request_configs.AdminURL + 'api/shops/',
      data,
      false,
      false,
      false,
      header
  )
}


async function getAccountUser(account_user_id) {
  const response = await Request(
      'post',
      'api/shops/get-admin-user-info/',
      {account_user_id: account_user_id}
  )
  if (response.data && response.data.status.isOK()) {
    store.commit("ACCOUNTUSERINFO", response.data.account_user);
  }
}

async function editInitialize() {
  return Request("post","api/shops/edit-initialize")
}

async function getAccountSettings(noLoading) {// 检查本地accessToken的登录状态
  const response = await Request('post', "api/shops/get-account-settings", null, noLoading);
  if (response.data && response.data.status.isOK()) {
    store.commit("LOGINSETTING", response.data.settings);
  }
  return response;
}

async function getShopAddress(data) {
  return await Request('post', 'api/shops/get-shop-address/', data);
}

export default {
  fetch,
  checkAction,
  fetchShops,
  getAllShops,
  getAccountUser,
  editInitialize,
  accountFetch,
  getAccountSettings,
  getShopAddress,
}